import { BaseWebsite } from '../core/BaseWebsite.js';
import { gsap } from 'gsap';

export class ElixirPage extends BaseWebsite {
  constructor() {
    super();
    this.setupElixirSpecific();
  }

  setupElixirSpecific() {
    this.setupHeroAnimations();
    this.setupHeroPinReveal('.elixir-hero', '#intro');
    this.setupIntroAnimation();
  }

  setupHeroAnimations() {
    // Hero title animation
    const heroLines = gsap.utils.toArray('.hero-line');
    const heroSubtitle = document.querySelector('.hero-subtitle');
    const heroButton = document.querySelector('.hero-button');

    // Set initial states for animation but keep CSS visibility control until animation
    gsap.set(heroLines, { y: 100, opacity: 0 });
    gsap.set(heroSubtitle, { y: 50, opacity: 0 });
    gsap.set(heroButton, { y: 30, opacity: 0 });

    const tl = gsap.timeline({
      delay: 0.5,
      onStart: () => {
        // Set visibility at the very beginning of the timeline
        document.documentElement.style.setProperty('--hero-visibility', 'visible');
      }
    });

    tl.to(heroLines, {
      y: 0,
      opacity: 1,
      duration: 1.2,
      stagger: 0.2,
      ease: "power2.out"
    })
    .to(heroSubtitle, {
      y: 0,
      opacity: 1,
      duration: 1,
      ease: "power2.out"
    }, "-=0.6")
    .to(heroButton, {
      y: 0,
      opacity: 1,
      duration: 0.8,
      ease: "power2.out"
    }, "-=0.4");
  }
}